import React, { useMemo } from 'react';
import ReactDOM from 'react-dom/client';
import DataContainer from 'elements/data-container';
import RouteContainer from 'elements/route-container';
import MainContainer from 'main-container';
import { getGlobalState } from 'state';
import routes from 'routes';
import 'utils/polyfills';
import dialog from 'dialog';
import './css/main.css';

interface MainInterface {
  render: () => void;
}

declare global {
  interface Window {
    React: typeof React;
    Main: MainInterface;
  }
}

window.React = React;

const container = document.createElement('div');
document.body.prepend(container);

const Main: MainInterface = (window.Main = {
  render: () => void 0,
});

const App = (props) => {
  const [render, setRender] = React.useState(false);

  Main.render = () => {
    setRender(!render);
  };

  useMemo(() => {
    if ('serviceWorker' in navigator && import.meta.env.PROD) {
      console.log('[ServiceWorker] Event registration activated');

      // Register the service worker when the page is loaded
      window.addEventListener('load', () => {
        console.log('[ServiceWorker] Registering service worker');
        navigator.serviceWorker.register('/service-worker.js', {
          scope: '/',
        });
      });

      // Register a service worker to support offline experience and quick subsequent page loads
      // When a new service worker is available, re-load the page
      navigator.serviceWorker.oncontrollerchange = () => {
        if (document.hidden) {
          dialog.show_notification(
            'Softball.app has been updated, this page will be automatically refreshed. You will not lose any data you have submitted.',
            () => {
              window.location.reload();
            }
          );
        } else {
          window.location.reload();
        }
      };
    }
  }, []);

  return (
    <DataContainer
      url="server/current-account"
      onRequestComplete={async (data: any) => {
        if (data.email) {
          console.log(`[AUTH] Active User: ${data.email}`);
          getGlobalState().setActiveUser(data.email);
          getGlobalState().sync();
        } else {
          console.log(`[AUTH] Not logged in`);
        }
      }}
    >
      {({ data, loading }) => {
        return (
          <RouteContainer routes={routes}>
            {(routeProps) => {
              return (
                <MainContainer
                  main={Main}
                  data={data}
                  loading={loading}
                  {...routeProps}
                />
              );
            }}
          </RouteContainer>
        );
      }}
    </DataContainer>
  );
};

(function () {
  const root = ReactDOM.createRoot(container);
  root.render(<App />);
})();

let _resize_timeout: ReturnType<typeof setTimeout> | null = null;
window.addEventListener('resize', function () {
  if (_resize_timeout !== null) {
    clearTimeout(_resize_timeout);
  }
  _resize_timeout = setTimeout(Main.render, 100);
});
